
import _ from 'lodash';

export default {install(Vue) {
    // const numberf = (value, decimals = 2) => {
    //     return _.floor(value, 2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    // }
    const number_with_comma = (value) => {
        return _.floor(value, 2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1");
    }
    const uppercase = (value,by = 'all') => {
        switch (by) {
            case 'first':
                return (!value)?'':value.charAt(0).toUpperCase() + value.slice(1);
            case 'all':
                return (!value)?'':value.toUpperCase();
        }
    }
    const date = (value) => {
        return (value.length <= 10)?value:value.substr(0,10);
        // return (value.length <= 10)?value:value.substr(0,value.length-3);
    }
    const dateFormat = (date, format = 'YYYY-MM-DD') => {
        if (!date) return '';
        const d = new Date(date);
        if (isNaN(d.getTime())) return '';
        const months = [
            'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
            'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
        ];
        const pad = (n) => String(n).padStart(2, '0');
        const hours = d.getHours();
        const tokens = {
            YYYY: d.getFullYear(),
            MMM: months[d.getMonth()], //mes con texto
            MM: pad(d.getMonth() + 1),
            DD: pad(d.getDate()),
            D: d.getDate(), //Día sin cero inicial
            HH: pad(hours), //Hora de 24 h, sin cero inicial
            H: hours,
            hh: pad(hours % 12 || 12), //Hora de 12 h, sin cero inicial
            h: hours % 12 || 12,
            mm: pad(d.getMinutes()),
            ss: pad(d.getSeconds()),
            a: hours < 12 ? 'am' : 'pm',
            A: hours < 12 ? 'AM' : 'PM',
        };

        return format.replace(
            /YYYY|MMM|MM|DD|HH|hh|mm|ss|D|H|h|a|A/g,
            token => tokens[token]
        );
    };

    const addressDescription = (name, city, state) => { 
        return [name, city, state].filter(Boolean).join(' · '); 
    }
    const number = (value, digits = 0) => { 
        return new Intl.NumberFormat('es-MX', { maximumFractionDigits: digits }).format(Number(value) || 0);
    }
    const distance = (meters) => { 
        return number(Number(meters) / 1000, 1); 
    }
    const duration = (minutes) => {
      const value = Number(minutes) || 0;
      return value >= 60 ? `${Math.floor(value / 60)}h ${String(value % 60).padStart(2, '0')}m` : `${value} min`;
    }

    // funciones disponibles en todos los componentes
    Vue.prototype.$number_with_comma = number_with_comma;
    Vue.prototype.$uppercase = uppercase;
    Vue.prototype.$date = date;
    Vue.prototype.$dateFormat = dateFormat;
    Vue.prototype.$number = number;
    Vue.prototype.$addressDescription = addressDescription;
    Vue.prototype.$distance = distance;
    Vue.prototype.$duration = duration;

  
}}